/**
 * The display string we surface for a user in lists, pickers, audit summaries,
 * and server-side label enrichment. The rule is `"firstName lastName" → email`
 * — the legal name, NOT `preferredName`: we want one canonical identity on
 * records and audit trails. Falls back to email so the result is non-empty.
 *
 * Lives in `@clockwise/shared` (depended on by both the web app and the API) so
 * the web UI and the server's read-response enrichment apply the exact same
 * rule — no per-call-site reimplementation that can drift.
 */
export function userDisplayName(u: {
  firstName?: string | null;
  lastName?: string | null;
  email: string;
}): string {
  const full = `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim();
  return full || u.email;
}
